import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    IconButton,
    InputAdornment,
    Box
  } from "@mui/material";
  import { Visibility, VisibilityOff } from "@mui/icons-material";
  import { useEffect, useState } from "react";
  import Redas from 'assets/images/auth/redas_result.webp';

  const defaultProjectid = "44004a1b-b0a5-4cf1-bb7c-9f39b112ea60"
  const defaultUsername = "redasapiuser"
  const defaultPassword = "tH/dmt{CA7m:2@xa"
  
  export default function LoginConnectorDialog({
    open,
    onCancel,
    onConfirm,
  }) {
    const [form, setForm] = useState({
      username: "",
      password: "",
      projectId: ""
    });

    useEffect(() => {
      const val = {
        username: defaultUsername,
        password: defaultPassword,
        projectId: defaultProjectid
      }
      setForm(val)
    }, [])
    

  
    const [showPassword, setShowPassword] = useState(false);
  
    const handleChange = (e) => {
      setForm(prev => ({
        ...prev,
        [e.target.name]: e.target.value
      }));
    };
  
    const handleSubmit = () => {
      onConfirm(form); // 👈 send all inputs
    };
  
    return (
      <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>

        <DialogContent>
        {/* 🔹 Connector Image */}
          <Box
            display="flex"
            justifyContent="center"
            mb={2}
          >
            <Box
              component="img"
              src={Redas}
              alt={"redas"}
              sx={{
                width: 72,
                height: 72,
                objectFit: "contain"
              }}
            />
          </Box>

        <Stack spacing={2}>
          <TextField
            label="Username"
            name="username"
            value={form.username}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Password"
            name="password"
            type={showPassword ? "text" : "password"}
            value={form.password}
            onChange={handleChange}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(v => !v)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Redas Project ID"
            name="projectId"
            value={form.projectId}
            onChange={handleChange}
            fullWidth
          />
        </Stack>
      </DialogContent>
  
        <DialogActions>
          <Button onClick={onCancel} color="inherit">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={!form.username || !form.password || !form.projectId}
          >
            Connect
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  